var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container blog-articles"},[_c('h1',[_vm._v("BLOG ARTICLE")]),_vm._v(" "),_c('div',{staticClass:"blog-headline"},[_c('img',{attrs:{"src":require("../assets/img/blog-placeholder.png"),"alt":""}})]),_vm._v(" "),_c('button',[_vm._v("Learn More")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-391313ec","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BlogArticles.vue
// module id = 222
// module chunks = 0